import { createRoot } from 'react-dom/client'

import { validateState } from '@/logic/validation'
import { loadUniques } from 'data/load'
import Store from 'store'
import OverlayRoot from 'ui/utils/OverlayManager'

import { Api } from 'api'
import { Leveling } from 'leveling/leveling'
import Session from 'store/session'

import { isDev } from '@/common'
import { levelingStores } from '@/leveling/common'
import { MainStoreProvider } from '@maxroll-media-group/common-libs'
import './Crafting.scss'

function LevelingApp({ stores, metadataId }: { stores: Record<string, Store>; metadataId: string }) {
  const leveling = Store.useEmbed()
  if (!leveling || leveling.type !== 'leveling') return null

  return <Leveling embed={leveling} stores={stores} metadataId={metadataId} />
}

document.addEventListener('DOMContentLoaded', async () => {
  const domNode = document.querySelector('.poeplanner-leveling')
  if (!domNode) return

  const session = new Session()
  const api = new Api(session.dispatch)

  const uniquesLoaded = loadUniques()

  const match = window.location.pathname.match(/\/poe-leveling\/(\w{8,9})\/(\d+)$/)
  if (!match) return

  const response = await api.load(match[1])

  await uniquesLoaded
  const { data, ...imported } = response
  const result = await validateState(JSON.parse(data), imported)
  const id = parseInt(match[2])
  const index = result.embeds.findIndex((e) => e.id === id)
  result.activeEmbed = index

  const store = new Store(result)
  const stores = await levelingStores(store)
  if (!stores) return

  api.updateLoginFrontend()

  domNode.classList.add('poeplanner-wrapper')
  const root = createRoot(domNode)
  root.render(
    <MainStoreProvider
      isMobile={window.innerWidth < 640}
      isDev={isDev}
      userHasSub={localStorage.getItem('maxrollUserHasSub') === 'true'}>
      <Store.Provider store={store}>
        <Session.Provider store={session}>
          <OverlayRoot>
            <LevelingApp stores={stores} metadataId={`${match[1]}:${id}`} />
          </OverlayRoot>
        </Session.Provider>
      </Store.Provider>
    </MainStoreProvider>
  )
})
